import { render, staticRenderFns } from "./lawyer-payment-advance-panel.vue?vue&type=template&id=06652bf8&"
import script from "./lawyer-payment-advance-panel.vue?vue&type=script&lang=js&"
export * from "./lawyer-payment-advance-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports